import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { routes } from "./constants/routes";
import { ProvideAuth } from "./hooks/useAuth";
import { ChakraProvider } from "@chakra-ui/react";

import LandingPage from "./pages/LandingPage";
import ScratchathonPage from "./pages/ScratchathonPage";

import "./styling/main.css";
import "./styling/custom.css";
import LearnScratchPage from "./pages/LearnScratchPage";
import Footer from "./components/Footer";

const App = () => {
  return (
    <ChakraProvider>
      <ProvideAuth>
        <Router>
          <Route exact path={routes.home}>
            <LandingPage />
          </Route>

          <Route exact path={routes.scratchathon}>
            <ScratchathonPage />
          </Route>

          <Route exact path={routes.learnscratch}>
            <LearnScratchPage />
          </Route>
        </Router>

        <Footer />
      </ProvideAuth>
    </ChakraProvider>
  );
};

export default App;
